var _style, _g;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgHouse = function SvgHouse(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "house_svg__Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: 0,
    y: 0,
    viewBox: "0 0 48 48",
    style: {
      enableBackground: "new 0 0 48 48"
    },
    xmlSpace: "preserve",
    width: "1em",
    height: "1em"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".house_svg__st0{stroke-width:2;stroke-miterlimit:10}")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "house_svg__House",
    stroke: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    className: "house_svg__st0",
    d: "M35 47H13c-4.4 0-8-3.6-8-8V17L24 1l19 16v22c0 4.4-3.6 8-8 8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    className: "house_svg__st0",
    d: "M19 47V33h10v14"
  }))));
};
export default SvgHouse;